// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1711":"b950a18f","2020":"b950a18f"}[chunkId] + ".chunk.css";
};